import { RoomService } from "./../../../../../../apps/resource-portal/src/app/services/room.service";
import { AcquisitionService } from "./../../../../../../apps/resource-portal/src/app/services/acquisition.service";
import { ProjectModel } from "./../../../../../../apps/resource-portal/src/app/pages/project/models/project-model";
import { ProjectService } from "apps/resource-portal/src/app/services/project.service";
import { AlertDialogComponent } from "libs/shared/src/lib/components/alert-dialog/alert-dialog.component";
import {
  AMPS,
  OUTLET_TYPE,
  DRAINSIZE,
  EMPTY_GUID,
} from "apps/resource-portal/src/app/constants/app.constant";
import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ElementRef,
  ViewChild,
  OnChanges,
  SimpleChanges,
  AfterViewInit,
  DoCheck,
} from "@angular/core";
import {
  UntypedFormGroup,
  UntypedFormArray,
  UntypedFormBuilder,
  Validators,
  UntypedFormControl,
  AbstractControl,
} from "@angular/forms";
import { BehaviorSubject, debounceTime, forkJoin, pairwise, startWith, Subject, take, takeUntil, timer } from "rxjs";
import { CutSheetService } from "apps/resource-portal/src/app/services/cut-sheet.service";
import { DialogService } from "libs/core/src/lib/services/dialog.service";
import { NgbActiveModal, NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { CutsheetModel, ManufacturerModel } from "../../models/cutsheet-model";

import { NgxGalleryImageSize, NgxGalleryOptions } from "@kolkov/ngx-gallery";
import { NgxGalleryImage } from "@kolkov/ngx-gallery";
import { NgxGalleryAnimation } from "@kolkov/ngx-gallery";
import { CommonUtils } from "libs/core/src/lib/utils/common.utils";
import { AuthService } from "apps/resource-portal/src/app/services/auth.service";
import { AddJsnRoomComponent } from "../add-jsn-room/add-jsn-room.component";
import { Router } from "@angular/router";
import { AddAccountDialogComponent } from "../add-account-dialog/add-account-dialog.component";
import { AutocompleteComponent } from "angular-ng-autocomplete";
import { PrivilegeService } from "apps/resource-portal/src/app/services/privilege.service";
import { CutsheetImagesComponent } from "../cutsheet-images/cutsheet-images.component";
import * as _ from "lodash"; // Import lodash
import { CutsheetGalleryComponent } from "../cutsheet-gallery/cutsheet-gallery.component";
import { InfoDialogComponent } from "../info-dialog/info-dialog.component";

@Component({
  selector: "concourse-cutsheet-details",
  templateUrl: "./cutsheet-details.component.html",
  styleUrls: ["./cutsheet-details.component.scss"],
})
export class CutsheetDetailsComponent
  implements OnInit, OnChanges, AfterViewInit, OnInit {
  @Input() cutsheetId: string;
  @Input() isReadOnly = false;
  @Input() basicEdit = false;
  @Input() projectId: string;
  @Input() projectType: any;
  @Input() projectName: string;
  @Input() roomByRoomId: string;
  @Input() departmentId: string;
  @Input() action: string = null;
  @Input() isFromMilStd: boolean = false;
  @Input() isFromCloudLib: boolean = false;
  @Input() isFromMainDB: boolean = false;
  @Input() showglbcopy: boolean = false;

  @Output() onJsnSubmit = new EventEmitter();
  @Output() isMilStdRecord = new EventEmitter();
  @Output() isCloudLibRecord = new EventEmitter();
  @Output() isImageUploaded = new EventEmitter();
  imageChanged: boolean = false
  clibProjectId = null;
  public userName = null;
  currentJSNOther = "";
  JsnName = "";
  // updatedProject = null;

  amps = AMPS;
  drain_size: any;
  outlet_type = OUTLET_TYPE;

  newRoomData = [];
  filteredRoomData: any[] = [];
  availableDepartments: any[] = [];
  selectedDepartments: any[] = [];
  sortColumn: string = null;

  jsnList: CutsheetModel[];
  projectList: ProjectModel[];
  selectedProject: ProjectModel;
  currentProject = null;
  selectedJSN: CutsheetModel = null;
  manufacturerList: ManufacturerModel[] = [];
  allManufacturerList: ManufacturerModel[] = [];
  selectedManufacturer: ManufacturerModel;
  selectedThirdPartVendor: any;
  selectedDealerInformation: any;

  public cutSheetForm: UntypedFormGroup;
  manufacturerForm: UntypedFormGroup;
  manufacturerContactForm: UntypedFormGroup;

  allUtilities = [];
  cutsheetDetails: any = [];
  files: any = [];
  acquisitionCodes = [];
  // <mildodhide> dodcatcodes = [];
  annotationImage: any = [];
  isImageDelete = false;
  $unsubscribe = new Subject<void>();
  createdAccount: any = [];
  @ViewChild("file", { static: false }) file: ElementRef<HTMLElement>;

  @ViewChild(CutsheetGalleryComponent) gallery: CutsheetGalleryComponent

  galleryOptions: NgxGalleryOptions[];
  galleryImages: NgxGalleryImage[];
  take = 10;
  images: any = [];
  deletedImages: any = {};
  deleletedImageValuesArray: any;
  finalNotDeletedImages: any = [];
  projectDetails: any = null;
  allInstalledBy: any = [];
  allSubtrades: any = [];
  allInstallationArea: any = [];
  selectedinstallationarea: any;
  selectedinstalledby: any;
  selectedsubtrades: any = [];
  isManufactureInfo: boolean = true;
  isUtilityRequirements: boolean = true;
  isInstallationInfo: boolean = true;
  isQuantityLocation: boolean = true;
  isInformationDetails: boolean = true;
  @Input() isJsnInfo: boolean = true;
  utilitylengths: any = [];
  isManufactureSelected: boolean = false;
  isDealerSelected: boolean = false;
  isVendorSelected: boolean = false;
  dealerForm: UntypedFormGroup;
  loadingManufacturerList: boolean = true;
  user: any;
  pendingApprovals: any = {};
  pendingApprovalsArray: any[] = [];
  initialValue: any = {};

  makeReadOnly$ = new BehaviorSubject<boolean>(false);
  globalChange: { isGlobal: boolean; old_jsno?: string; old_jsnother?: string; jsnotherchange?: boolean } = { isGlobal: false };

  // <mildodhide>projectTypes: any = {
  //   "VA": "700000001",
  //   "DOD": "700000000",
  // }

  constructor(
    private _cutSheetService: CutSheetService,
    private _formBuilder: UntypedFormBuilder,
    public activeModal: NgbActiveModal,
    private _projectService: ProjectService,
    private _dialogService: DialogService,
    private _acquisitionService: AcquisitionService,
    private _roomService: RoomService,
    private _authService: AuthService,
    private _modalService: NgbModal,
    private router: Router,
    private privilegeService: PrivilegeService
  ) {
    (window as any).cd = this;
  }
  isManufactureFocused: boolean = false;
  hasAccess(role: string) {
    return this.privilegeService.userAccess(role);
  }
  onFocusOut(e: any, type: any) {
    setTimeout(() => {
      console.log(
        "clearing",
        this.isManufactureSelected,
        this.isDealerSelected,
        this.isVendorSelected
      );
      if (type == "manufacturer" && !this.isManufactureSelected) {
        e.target.value = null;
        this.onClearAutoComplete(type);
      } else if (type == "dealer" && !this.isDealerSelected) {
        e.target.value = null;
        this.onClearAutoComplete(type);
      } else if (type == "vendor" && !this.isVendorSelected) {
        e.target.value = null;
        this.onClearAutoComplete(type);
      }
      this.allManufacturerList = [];
    }, 500);
  }
  ngOnChanges(): void {
    this.initGalleryOptions();
    this._cutSheetService.isJsnAddedToRooms.subscribe((data) => {
      if (data) {
        this.projectDetails = data;
      }
    });
  }

  getFormPristine() {
    return this.cutSheetForm;
  }

  setFormPristine() {
    return this.cutSheetForm.markAsDirty();
  }

  getDepartments() {
    this._roomService
      .getDepartmentByProjectId(this.projectId, false)
      .pipe(takeUntil(this.$unsubscribe))
      .subscribe((result) => {
        if (result) {
          this.availableDepartments = CommonUtils.sortByKey(
            result,
            "departmentname"
          );
        }
      });
  }
  ngOnInit(): void {
    this.projectDetails = null;
    this.userName = this._authService.$user.value?.email;
    console.log("logged in user email: ", this.userName);
    this.getCloudLibraryProjectInfo();
    this.initGalleryOptions();
    // this.getAllProjects();
    this.getAllAcquisitionCodes();
    //this.getAllManufacturerList();
    this.getAllInstallBy();
    this.getAllSubtrades();
    this.getAllInstallationArea();
    this.getAllUtilityLength();
    this.getAllDrainSize();
    this.getDepartments();
    this.images = [];
    this.files = [];

    // this._commonService.selectedProject.subscribe((res)=> {
    //   this.updatedProject = res;
    //   console.log("updated");
    // });

    this.buildCutsheetForm();
    if (this.isReadOnly && this.cutsheetId && this.cutsheetId !== "") {
      this.getCutsheetDetails(this.cutsheetId);
      this.getRxrByJsnId(this.cutsheetId);
    } else if (this.projectId !== "") {
      // this.getJSNList();
      // this.getAllManufacturerList();
      // this.getAllProjects();
    }
    this._cutSheetService.accountDetails.subscribe((res) => {
      console.log(res);

      if (res) {
        this.createdAccount = res;
        if (this.createdAccount) {
          this.getAllManufacturerList();
        }
      }
    });
  }

  bindCreatedAccount(res: any) {
    this.createdAccount = null;
    switch (res?.createdFrom) {
      case "dealer":
        const dealer = this.allManufacturerList.find(
          (item: any) => item.id == res?.id
        );

        this.cutSheetForm.get("dealer").reset();
        this.selectedDealerInformation = dealer;
        this.cutSheetForm.get("dealer").patchValue(dealer);

        this.cutSheetForm.get("dealer").markAsDirty();
        this.cutSheetForm.get("dealer").get("id").markAsDirty();
        this.isDealerSelected = true;
        console.log(this.cutSheetForm);

        this.setFormPristine();
        break;
      case "manufacturer":
        const manufacturer = this.allManufacturerList.find(
          (item: any) => item.id == res?.id
        );
        this.cutSheetForm.get("manufacturer").get("manufacturer").reset();
        this.selectedManufacturer = manufacturer;
        this.manufacturerForm.patchValue(manufacturer);
        this.cutSheetForm
          .get("manufacturer")
          .get("manufacturer")
          .patchValue(manufacturer);
        this.cutSheetForm.get("manufacturer").markAsDirty();
        this.cutSheetForm.get("manufacturer").get("manufacturer").markAsDirty();
        this.cutSheetForm
          .get("manufacturer")
          .get("manufacturer")
          .get("id")
          .markAsDirty();
        this.isManufactureSelected = true;
        this.setFormPristine();
        break;
      case "3rd party vendor":
        const vendor = this.allManufacturerList.find(
          (item: any) => item.id == res?.id
        );
        this.cutSheetForm.get("thirdpartyvendor").reset();
        this.selectedThirdPartVendor = vendor;
        this.cutSheetForm.get("thirdpartyvendor").patchValue(vendor);
        this.cutSheetForm.get("thirdpartyvendor").markAsDirty();
        this.cutSheetForm.get("thirdpartyvendor").get("id").markAsDirty();
        this.isVendorSelected = true;
        this.setFormPristine();
        break;
    }
  }

  getRxrByJsnId(cutsheetId: string) {
    this._roomService
      .getRxrByJsnId(cutsheetId)
      .pipe(takeUntil(this.$unsubscribe))
      .subscribe((res) => {
        if (res && res.length > 0) {
          res.forEach((item) => {
            let obj: any = {};
            obj.roomnumber = item?.name;
            obj.roomname = item?.roomname;
            obj.quantity = item?.quantity;
            obj.qtyinroom = item?.qtyinroom;
            obj.department = item?.department?.departmentname;
            this.newRoomData.push(obj);
          });
          this.onDeptSelectionChange();
        }
      });
  }

  onDeptSelectionChange() {
    if (!this.selectedDepartments || this.selectedDepartments.length === 0) {
      this.filteredRoomData = [...this.newRoomData];
    } else {
      this.filteredRoomData = this.newRoomData.filter((r) =>
        this.selectedDepartments.some((d) => d.departmentname === r.department)
      );
    }
  }

  isAllDeptsSelected(): boolean {
    return this.availableDepartments.length > 0 &&
      this.availableDepartments.length === this.selectedDepartments.length;
  }

  toggleSelectAllDepts(event: any): void {
    if (event.target.checked) {
      this.selectedDepartments = [...this.availableDepartments];
    } else {
      this.selectedDepartments = [];
    }
    this.onDeptSelectionChange();
  }

  getAllAcquisitionCodes() {
    console.log("acquisition api==>", !!this.projectType);

    if (!this.projectType) return;

    //<mildodhide> if (this.isFromMilStd) {
    //   forkJoin([
    //     this._acquisitionService
    //       .getAllAcquisitionCodes(this.projectTypes['VA']),
    //     this._acquisitionService
    //       .getAllAcquisitionCodes(this.projectTypes['DOD'])
    //   ])
    //     .pipe(takeUntil(this.$unsubscribe))
    //     .subscribe(([vaCodes, dodCodes]) => {
    //       if (vaCodes && vaCodes.length > 0) {
    //         this.acquisitionCodes = vaCodes;
    //         console.log("fetched codes==>", vaCodes);
    //       }
    //       if (dodCodes && dodCodes.length > 0) {
    //         this.dodcatcodes = dodCodes;
    //         console.log("fetched codes==>", dodCodes);
    //       }
    //     });
    //   return;
    // }

    this._acquisitionService
      .getAllAcquisitionCodes(this.projectType)
      .pipe(takeUntil(this.$unsubscribe))
      .subscribe((result) => {
        if (result && result.length > 0) {
          this.acquisitionCodes = result;
          console.log("fetched codes==>", result);
        }
      });
  }

  initGalleryOptions() {
    this.galleryOptions = [
      {
        thumbnails: false,
        width: "400px",
        height: "400px",
        thumbnailsColumns: this.isReadOnly ? 4 : 3,
        imageAnimation: NgxGalleryAnimation.Slide,
        imageSize: NgxGalleryImageSize.Contain,
        thumbnailsArrowsAutoHide: true,
        thumbnailActions: !this.isReadOnly
          ? [
            {
              icon: "fa fa-close",
              onClick: this.deleteImage.bind(this),
              titleText: "delete",
            },
          ]
          : null,
      },
      {
        breakpoint: 800,
        width: "300px",
        height: "100%",
        imagePercent: 80,
        thumbnailsPercent: 20,
        thumbnailsMargin: 20,
        thumbnailMargin: 20,
      },
      {
        breakpoint: 300,
        preview: false,
      },
    ];
  }

  sortByColumn(arr, columnName, order) {
    this.sortColumn = columnName;
    arr = CommonUtils.sortByKey(arr, columnName, order ? "ASC" : "DESC");
  }

  getAllDrainSize() {
    this._cutSheetService
      .getAllDrainSize()
      .pipe(takeUntil(this.$unsubscribe))
      .subscribe((result) => {
        if (result && result?.data?.length > 0) {
          this.drain_size = result?.data;
        }
      });
  }

  buildCutsheetForm(): void {
    this.cutSheetForm = this._formBuilder.group({
      id: [""],
      name: ["", Validators.required],
      jsnother: [""],
      height: [0],
      width: [0],
      depth: [0],
      project: [null],
      quantity: [0],
      qtyinroom: new UntypedFormControl(0),
      cost: [0],
      unitcost: [0],
      totalcost: [0],
      mtr: [""],
      description: [""],
      nomenclature: [""],
      additionalnotes: [""],
      comment: [""],
      specification: [""],
      modelnumber: [""],
      modelname: [""],
      acquisitioncode: this._formBuilder.group({
        id: [""],
        name: [""],
      }),
      //<mildodhide> dodcatcode: this._formBuilder.group({
      //   id: [""],
      //   name: [""],
      // }),
      manufacturer: this.buildManufacturerForm(),
      utility_1: new UntypedFormGroup({
        id: new UntypedFormControl(null),
        name: new UntypedFormControl(null),
        type: new UntypedFormControl(null),
      }),
      utility_2: new UntypedFormGroup({
        id: new UntypedFormControl(null),
        name: new UntypedFormControl(null),
        type: new UntypedFormControl(null),
      }),
      utility_3: new UntypedFormGroup({
        id: new UntypedFormControl(null),
        name: new UntypedFormControl(null),
        type: new UntypedFormControl(null),
      }),
      utility_4: new UntypedFormGroup({
        id: new UntypedFormControl(null),
        name: new UntypedFormControl(null),
        type: new UntypedFormControl(null),
      }),
      utility_5: new UntypedFormGroup({
        id: new UntypedFormControl(null),
        name: new UntypedFormControl(null),
        type: new UntypedFormControl(null),
      }),
      utility_6: new UntypedFormGroup({
        id: new UntypedFormControl(null),
        name: new UntypedFormControl(null),
        type: new UntypedFormControl(null),
      }),
      utility_additionaloutlets: 0,
      amps: 0,
      utility_data: false,
      utility_wallblocking: false,
      utility_dedicatedcircuits: false,
      utility_emergencypower: false,
      utility_includesinstallations: false,
      utility_includesoperator: false,
      utility_includesshipping: false,
      utility_isinstalledbythirdparty: false,
      utility_numberofdrops: 0,
      utility_outlettype: null,
      utility_trainingneeded: false,
      showmodel: false,
      modelurl: null,
      defaultnote: null,
      worksurfaces: false,
      copymilstdglb: false,
      installationarea: 0,
      requiremodel: false,
      installedby: 0,
      mountedheight: 0,
      installationdate: "",
      buildingprotectionreq: false,
      verifiedequipfit: false,
      weightlbs: 0,
      subtradereq: false,
      subtrades: 0,
      loadingdockdestination: false,
      loadingdockorigin: false,
      elevatororigin: false,
      destination: false,
      installationnote: "",
      thirdpartyvendor: new UntypedFormGroup({
        id: new UntypedFormControl(null),
        name: new UntypedFormControl(null),
        count: new UntypedFormControl(0),
      }),
      thirdpartypocname: "",
      thirdpartypocphone: "",
      thirdpartypocemail: "",
      thirdpartyfieldsurvey: false,
      thirdpartyinstallcost: 0,
      thirdpartyinstalldate: new Date().toISOString(),
      thirdpartyinstallcompletedate: new Date().toISOString(),
      calibrationtesting: false,
      shopdrawings: false,
      utility_warrantyterm: 0,
      shopdrawingsreceiveddt: "",
      mmdepthwidth: 0,
      mmdepth: 0,
      mmdepthheight: 0,
      utility1plumbinglength: null,
      utility2electricallength: null,
      utility3medicalgaslength: null,
      utility4miscgaslength: null,
      utility5nonmedgaslength: null,
      utility6miscellaneouslength: null,
      datautilitylength: null,
      dcutilitylength: null,
      eputilitylength: null,
      dealer: new UntypedFormGroup({
        id: new UntypedFormControl(null),
        name: new UntypedFormControl(null),
        status: new UntypedFormControl(null),
        email: new UntypedFormControl(null),
        phone: new UntypedFormControl(null),
        count: new UntypedFormControl(0),
      }),
      manufacturerurl: "",
      drainsize: 1,
    });

    this.getAllUtilityItemsList();
    // this.cutSheetForm.valueChanges.subscribe((res:any)=>{
    //   // console.log(res);
    //   // debugger
    //   console.log(this.cutSheetForm.get('dealer').get('name'));

    // })
    if (this.cutsheetId && !this._authService.$user.value.securityrole.includes('GLOBAL_ADMIN')) {
      this.cutSheetForm.get("jsnother").disable();
      this.cutSheetForm.get("name").disable();
    }
  }

  getAllInstallBy() {
    this._cutSheetService
      .getAllInstallBy()
      .pipe(takeUntil(this.$unsubscribe))
      .subscribe((result) => {
        if (result) {
          this.allInstalledBy = result.data;
        }
      });
  }

  getAllInstallationArea() {
    this._cutSheetService
      .getAllInstallationArea()
      .pipe(takeUntil(this.$unsubscribe))
      .subscribe((result) => {
        if (result) {
          this.allInstallationArea = result.data;
        }
      });
  }

  getAllSubtrades() {
    this._cutSheetService
      .getAllSubtrades()
      .pipe(takeUntil(this.$unsubscribe))
      .subscribe((result) => {
        if (result) {
          this.allSubtrades = result.data;
        }
      });
  }

  getAllUtilityItemsList() {
    if (!this.projectType) return;
    this._cutSheetService
      .getUtilityItemsList(this.projectType)
      .pipe(takeUntil(this.$unsubscribe))
      .subscribe((res) => {
        this.allUtilities = res.data || [];
      });
  }

  filterUtilitiesByType(type) {
    if (this.allUtilities.length > 0) {
      return this.allUtilities.filter((u) => {
        return u.type == type;
      });
    }
    return [];
  }
  onChangeUtility(event, utilityType) {
    if (event === null || event === undefined) {
      return;
    }

    if ((+event === 1 || +event === 0) && utilityType === "drainSize") {
      this.cutsheetDetails["drainsize"] = +event;
      this.cutSheetForm.controls["utility1plumbinglength"].setValue(-1);
      this.cutSheetForm.controls["utility1plumbinglength"].markAsDirty();
    } else if (
      +event !== 1 &&
      !!+event &&
      +event > 0 &&
      utilityType === "drainSize"
    ) {
      this.cutsheetDetails["drainsize"] = +event;

      if (this.cutSheetForm.controls["utility1plumbinglength"].value > 0)
        return;
      this.cutSheetForm.controls["utility1plumbinglength"].setValue("6");
      this.cutSheetForm.controls["utility1plumbinglength"].markAsDirty();
    }

    //utility1

    if (
      event === "088518cf-89e3-e911-a837-000d3a3b5b14" &&
      utilityType === "utility_1"
    ) {
      this.cutsheetDetails["drainsize"] = 1;
      this.cutSheetForm.controls["drainsize"].setValue(-1);
      this.cutSheetForm.controls["drainsize"].markAsDirty();

      this.cutSheetForm.controls["utility1plumbinglength"].setValue(-1);
      this.cutSheetForm.controls["utility1plumbinglength"].markAsDirty();
      this.getDrainSizeMetaData(1, "name");
    }

    // utility2
    if (
      event === "355fcdd7-89e3-e911-a82d-000d3a3b52e2" &&
      utilityType === "utility_2"
    ) {
      const utility_2 = this.filterUtilitiesByType(2).filter(
        (item: any) => item.id === event
      )[0];
      this.cutsheetDetails["utility_2"] = utility_2;
      this.cutSheetForm.get("utility_2").get("name").setValue(utility_2.name);
      this.cutSheetForm.controls["utility2electricallength"].setValue(-1);
      this.cutSheetForm.controls["utility2electricallength"].markAsDirty();
    } else if (
      event !== "355fcdd7-89e3-e911-a82d-000d3a3b52e2" &&
      utilityType === "utility_2"
    ) {
      const utility_2 = this.filterUtilitiesByType(2).filter(
        (item: any) => item.id === event
      )[0];
      this.cutsheetDetails["utility_2"] = utility_2;
      this.cutSheetForm.get("utility_2").get("name").setValue(utility_2.name);
      if (this.cutSheetForm.controls["utility2electricallength"].value > 0)
        return;
      this.cutSheetForm.controls["utility2electricallength"].setValue("6");

      this.cutSheetForm.controls["utility2electricallength"].markAsDirty();
    }

    // utility_dedicatedcircuits
    if (
      event?.target?.checked === false &&
      utilityType === "utility_dedicatedcircuits"
    ) {
      this.cutsheetDetails["utility_dedicatedcircuits"] = event.target.checked;
      this.cutSheetForm.controls["dcutilitylength"].setValue(-1);
      this.cutSheetForm.controls["dcutilitylength"].markAsDirty();
    } else if (
      event?.target?.checked &&
      utilityType === "utility_dedicatedcircuits"
    ) {
      this.cutsheetDetails["utility_dedicatedcircuits"] = event.target.checked;
      this.cutSheetForm.controls["dcutilitylength"].setValue("6");

      this.cutSheetForm.controls["dcutilitylength"].markAsDirty();
    }

    // utility_emergencypower
    if (
      event?.target?.checked === false &&
      utilityType === "utility_emergencypower"
    ) {
      this.cutsheetDetails["utility_emergencypower"] = event.target.checked;
      this.cutSheetForm.controls["eputilitylength"].setValue(-1);
      this.cutSheetForm.controls["eputilitylength"].markAsDirty();
    } else if (
      event?.target?.checked &&
      utilityType === "utility_emergencypower"
    ) {
      this.cutsheetDetails["utility_emergencypower"] = event.target.checked;
      this.cutSheetForm.controls["eputilitylength"].setValue("6");

      this.cutSheetForm.controls["eputilitylength"].markAsDirty();
    }

    //utility 3
    if (
      event === "e0c759ca-8fe3-e911-a833-000d3a3b5933" &&
      utilityType === "utility_3"
    ) {
      const utility_3 = this.filterUtilitiesByType(5).filter(
        (item: any) => item.id === event
      )[0];
      this.cutsheetDetails["utility_3"] = utility_3;
      this.cutSheetForm.get("utility_3").get("name").setValue(utility_3.name);

      this.cutSheetForm.controls["utility3medicalgaslength"].setValue(-1);
      this.cutSheetForm.controls["utility3medicalgaslength"].markAsDirty();
    } else if (
      event !== "e0c759ca-8fe3-e911-a833-000d3a3b5933" &&
      utilityType === "utility_3"
    ) {
      const utility_3 = this.filterUtilitiesByType(5).filter(
        (item: any) => item.id === event
      )[0];
      this.cutsheetDetails["utility_3"] = utility_3;
      this.cutSheetForm.get("utility_3").get("name").setValue(utility_3.name);

      if (this.cutSheetForm.controls["utility3medicalgaslength"].value > 0)
        return;
      this.cutSheetForm.controls["utility3medicalgaslength"].setValue("6");

      this.cutSheetForm.controls["utility3medicalgaslength"].markAsDirty();
    }

    //utility 4
    if (
      event === "91d751d6-8fe3-e911-a833-000d3a3b5933" &&
      utilityType === "utility_4"
    ) {
      const utility_4 = this.filterUtilitiesByType(6).filter(
        (item: any) => item.id === event
      )[0];
      this.cutsheetDetails["utility_4"] = utility_4;
      this.cutSheetForm.get("utility_4").get("name").setValue(utility_4.name);

      this.cutSheetForm.controls["utility4miscgaslength"].setValue(-1);
      this.cutSheetForm.controls["utility4miscgaslength"].markAsDirty();
    } else if (
      event !== "91d751d6-8fe3-e911-a833-000d3a3b5933" &&
      utilityType === "utility_4"
    ) {
      const utility_4 = this.filterUtilitiesByType(6).filter(
        (item: any) => item.id === event
      )[0];
      this.cutsheetDetails["utility_4"] = utility_4;
      this.cutSheetForm.get("utility_4").get("name").setValue(utility_4.name);

      if (this.cutSheetForm.controls["utility4miscgaslength"].value > 0) return;
      this.cutSheetForm.controls["utility4miscgaslength"].setValue("6");

      this.cutSheetForm.controls["utility4miscgaslength"].markAsDirty();
    }

    //utility 5
    if (
      event === "6081dde9-8fe3-e911-a834-000d3a3b5cdb" &&
      utilityType === "utility_5"
    ) {
      const utility_5 = this.filterUtilitiesByType(7).filter(
        (item: any) => item.id === event
      )[0];
      this.cutsheetDetails["utility_5"] = utility_5;
      this.cutSheetForm.get("utility_5").get("name").setValue(utility_5.name);

      this.cutSheetForm.controls["utility5nonmedgaslength"].setValue(-1);
      this.cutSheetForm.controls["utility5nonmedgaslength"].markAsDirty();
    } else if (
      event !== "6081dde9-8fe3-e911-a834-000d3a3b5cdb" &&
      utilityType === "utility_5"
    ) {
      const utility_5 = this.filterUtilitiesByType(7).filter(
        (item: any) => item.id === event
      )[0];
      this.cutsheetDetails["utility_5"] = utility_5;
      this.cutSheetForm.get("utility_5").get("name").setValue(utility_5.name);

      if (this.cutSheetForm.controls["utility5nonmedgaslength"].value > 0)
        return;
      this.cutSheetForm.controls["utility5nonmedgaslength"].setValue("6");

      this.cutSheetForm.controls["utility5nonmedgaslength"].markAsDirty();
    }

    //utility 6
    if (
      event === "c19070f4-8fe3-e911-a832-000d3a3b59b2" &&
      utilityType === "utility_6"
    ) {
      const utility_6 = this.filterUtilitiesByType(100000001).filter(
        (item: any) => item.id === event
      )[0];
      this.cutsheetDetails["utility_6"] = utility_6;
      this.cutSheetForm.get("utility_6").get("name").setValue(utility_6.name);

      this.cutSheetForm.controls["utility6miscellaneouslength"].setValue(-1);
      this.cutSheetForm.controls["utility6miscellaneouslength"].markAsDirty();
    } else if (
      event !== "c19070f4-8fe3-e911-a832-000d3a3b59b2" &&
      utilityType === "utility_6"
    ) {
      const utility_6 = this.filterUtilitiesByType(100000001).filter(
        (item: any) => item.id === event
      )[0];
      this.cutsheetDetails["utility_6"] = utility_6;
      this.cutSheetForm.get("utility_6").get("name").setValue(utility_6.name);

      if (this.cutSheetForm.controls["utility6miscellaneouslength"].value > 0)
        return;
      this.cutSheetForm.controls["utility6miscellaneouslength"].setValue("6");

      this.cutSheetForm.controls["utility6miscellaneouslength"].markAsDirty();
    }

    //utility data
    if (event?.target?.checked === false && utilityType === "utility_data") {
      // this.cutsheetDetails["utility_data"] = event.target.checked;
      this.cutSheetForm.controls["datautilitylength"].setValue(-1);
      this.cutSheetForm.controls["datautilitylength"].markAsDirty();

      if (this.cutsheetDetails.utility_numberofdrops > 0 || this.cutSheetForm.controls["utility_numberofdrops"].value > 0 || !this.cutSheetForm.controls["utility_numberofdrops"].value) {
        this.cutSheetForm.controls["utility_numberofdrops"].setValue("0");
        this.cutsheetDetails.utility_numberofdrops = 0;
      }
    } else if (event?.target?.checked && utilityType === "utility_data") {
      // this.cutsheetDetails["utility_data"] = event.target.checked;


      if (
        this.cutsheetDetails.datautilitylength == null ||
        this.cutsheetDetails.datautilitylength == -1 ||
        this.cutsheetDetails.datautilitylength == 6 ||
        this.cutsheetDetails.datautilitylength == 0
      ) {
        this.cutSheetForm.controls["datautilitylength"].setValue("6");
      } else {
        this.cutSheetForm.controls["datautilitylength"].setValue(
          this.cutsheetDetails.datautilitylength
        );
      }

      if (this.cutsheetDetails.utility_data == event.target.checked) {
        this.cutSheetForm.controls["utility_data"].markAsUntouched();
        this.cutSheetForm.controls["utility_data"].markAsPristine();
      }
      if (
        this.cutSheetForm.controls["datautilitylength"].value ==
        this.cutsheetDetails.datautilitylength
      ) {
        this.cutSheetForm.controls["datautilitylength"].markAsUntouched();
        this.cutSheetForm.controls["datautilitylength"].markAsPristine();
      } else {
        this.cutSheetForm.controls["datautilitylength"].markAsDirty();
      }

      // If data port is yes and if no of drops is 0 or empty then set it to 1
      // if data port is no and no of drops is grater than 0 then set it to 0
      // 
      if (this.cutSheetForm.controls["utility_numberofdrops"].value == null || this.cutSheetForm.controls["utility_numberofdrops"].value == -1 || this.cutSheetForm.controls["utility_numberofdrops"].value == 0) {
        this.cutSheetForm.controls["utility_numberofdrops"].setValue("1");
      } else {
        // this.cutSheetForm.controls["utility_numberofdrops"].setValue(this.cutsheetDetails.utility_numberofdrops);
      }
    }

    // utility_wallblocking
    if (event?.target?.checked && utilityType === "utility_wallblocking") {
      if (this.cutsheetDetails.utility_data == event.target.checked) {
        this.cutSheetForm.controls["utility_wallblocking"].markAsUntouched();
        this.cutSheetForm.controls["utility_wallblocking"].markAsPristine();
      }
    }
  }

  buildManufacturerForm(): any {
    return (this.manufacturerForm = this._formBuilder.group({
      id: [""],
      name: [""],
      manufacturer: this._formBuilder.group({
        id: [""],
        name: [""],
        modelname: [""],
        modelnumber: [""],
        primarycontact: this.buildManufacturerContactForm(),
      }),
    }));
  }

  transformGalleryImages(images) {
    if (images && images.length) {
      return images.map((img) => {
        return { small: img, medium: img, big: img };
      });
    } else {
      return [];
    }
  }

  buildManufacturerContactForm(): any {
    return (this.manufacturerContactForm = this._formBuilder.group({
      id: [""],
      name: [""],
      email: [""],
      phonenumber: [""],
    }));
  }

  resetCutsheetForm(): void {
    this.cutSheetForm.reset();
    this.images = [];
    this.files = [];
    this.galleryImages = [];
  }

  resetManufacturerForm(): void {
    this.manufacturerForm.reset();
  }

  getJSNList(searchStr?): void {
    this._cutSheetService
      .getJSNList(this.projectId, {
        take: 20,
        search: searchStr,
      })
      .pipe(takeUntil(this.$unsubscribe))
      .subscribe((result) => {
        if (result) {
          this.jsnList = result || [];
          this.jsnList =
            (result || []).map(item => {
              const jsnother = item?.jsnother ? ` ${item.jsnother}` : "";
              const nomenclature = item?.nomenclature ? ` - ${item.nomenclature}` : "";

              return {
                ...item,
                name: `${item.name || ""}${jsnother}${nomenclature}`
              };
            });
        }
      });
  }

  getJSNById(id: string): any {
    return new Promise((resolve, reject) => {
      this._cutSheetService
        .getCutsheetDetailByCutsheetId(id)
        .pipe()
        .subscribe((JSNDetail) => {
          return resolve(JSNDetail);
        });
    });
  }

  async onJsnSelected(event) {
    //this.selectedJSN = event;
    this.getRxrByJsnId(event.id);
    this.selectedJSN = await this.getJSNById(event.id);
    console.log(this.selectedJSN);
    this.showglbcopy = this.selectedJSN.showglbcopy
    this.loadJsnDepartments(this.selectedJSN.id);

    this.resetCutsheetForm();
    // if(!this.isReadOnly) {
    //   this.selectedJSN.utility_1 = this.selectedJSN?.utility_1?.id;
    //   this.selectedJSN.utility_2 = this.selectedJSN?.utility_2?.id;
    //   this.selectedJSN.utility_3 = this.selectedJSN?.utility_3?.id;
    //   this.selectedJSN.utility_4 = this.selectedJSN?.utility_4?.id;
    //   this.selectedJSN.utility_5 = this.selectedJSN?.utility_5?.id;
    //   this.selectedJSN.utility_6 = this.selectedJSN?.utility_6?.id;
    // }
    // this.images = this.selectedJSN.images;
    // this.galleryImages = this.transformGalleryImages(this.images);
    // console.log(this.selectedJSN);

    this.gallery.initializeImages(this.selectedJSN)

    this.cutSheetForm.patchValue(this.selectedJSN);
    console.log(this.cutSheetForm);

    let manufacturer = {
      id: this.selectedJSN?.manufacturer?.id,
      name: this.selectedJSN?.manufacturer?.name,
      manufacturer: {
        id: this.selectedJSN?.manufacturer?.id,
        name: this.selectedJSN?.manufacturer?.name,
        modelname: this.selectedJSN?.modelname,
        modelnumber: this.selectedJSN?.modelnumber,
      },
    };
    this.cutSheetForm.get("manufacturer").patchValue(manufacturer);

    // this.images = this.selectedJSN?.images || [];
    this.manufacturerList = [];
    this.selectedManufacturer = null;
    // this.getManufacturerList(this.selectedJSN.name);
  }

  // getManufacturerList(jsn): void {

  //   this._cutSheetService.getManufacturerList(jsn).pipe(
  //     takeUntil(this.$unsubscribe),
  //   ).subscribe((result) => {
  //     if (result) {
  //       this.manufacturerList = result.data.map(item => item.manufacturer) || [];
  //       if (this.manufacturerList.length > 0) {
  //         this.selectedManufacturer = this.manufacturerList[0];
  //         this.manufacturerForm.patchValue(this.manufacturerList[0]);
  //         this.resetManufacturerForm();
  //         if(!this.selectedJSN?.manufacturer)
  //           this.cutSheetForm.get('manufacturer').patchValue(result.data[0]);
  //       }
  //     }
  //   });
  // }

  getUserProjects(searchStr?) {
    this._authService.isLoggedIn.subscribe((value) => {
      if (value) {
        this.user = this._authService.$user.value;
      } else {
        this.user = null;
      }
    });
    this._projectService
      .getAllProjectList({ email: this.user?.email || null })
      .pipe(takeUntil(this.$unsubscribe))
      .subscribe((res: any) => {
        this.projectList = [];
        res.data.forEach((project) => {
          if (
            this.privilegeService.userProjectAccess(
              "PRV_CUTSHEET.CREATE",
              project.id
            )
          ) {
            this.projectList.push(project);
          }
        });
      });
  }
  getAllProjects(searchStr?) {
    this._projectService
      .getAllProjects({
        take: this.take,
        search: searchStr || "",
      })
      .pipe(takeUntil(this.$unsubscribe))
      .subscribe((res: any) => {
        this.projectList = res.data || [];
      });
  }

  getAllManufacturerList(searchStr?, type?): void {
    this._cutSheetService
      .getAllManufacturerList(searchStr)
      .pipe(takeUntil(this.$unsubscribe))
      .subscribe((result) => {
        if (result) {
          this.allManufacturerList = result.data || [];
          this.loadingManufacturerList = false;
          console.log(result);

          // if (!this.allManufacturerList.length) {
          //   this._dialogService.showToast(
          //     `No ${type} found. You can create ${type} by clicking of + icon`,
          //     "info"
          //   );
          //   if (type === "Manufacturer") {
          //     this.cutSheetForm.get("manufacturer").reset();
          //   }
          //   if (type === "Third Paty Vendor") {
          //     this.cutSheetForm.get("thirdpartyvendor").reset();
          //   }
          //   if (type === "Dealer") {
          //     this.cutSheetForm.get("dealer").reset();
          //   }
          // }
          if (this.createdAccount) {
            this.bindCreatedAccount(this.createdAccount);
          }
          setTimeout(() => {
            this._cutSheetService.accountDetails.next("");
          }, 0);
        }
      });
  }

  onManufacturerSelected(event, isFromHeader): void {
    console.log("selected");

    if (isFromHeader) {
      this.selectedManufacturer = event;
    }
    // debugger;
    this.cutSheetForm.get("manufacturer").get("manufacturer").reset();
    this.manufacturerForm.patchValue(event);
    this.cutSheetForm.get("manufacturer").get("manufacturer").patchValue(event);
    this.isManufactureSelected = true;
    this.allManufacturerList = [];
  }
  onDealerSelected(event, isFromHeader): void {
    console.log(event);

    this.cutSheetForm.get("dealer").reset();

    this.selectedDealerInformation = event;

    this.cutSheetForm.get("dealer").patchValue(event);
    this.createdAccount = null;
    this.setFormPristine();
    this.cutSheetForm.markAsDirty();
    this.isDealerSelected = true;
    console.log(this.cutSheetForm.value);
  }

  onThirdPartVendorSelected(event, isFromHeader): void {
    if (isFromHeader) {
      this.selectedThirdPartVendor = event;
    }
    this.cutSheetForm.get("thirdpartyvendor").reset();
    this.selectedThirdPartVendor = event;
    this.cutSheetForm.get("thirdpartyvendor").patchValue(event);
    this.isVendorSelected = true;
  }

  onChangeSearchThirdParty(val) {
    this.loadingManufacturerList = true;
    this.isVendorSelected = false;
    this.cutSheetForm.get("thirdpartyvendor").reset();
    this.cutSheetForm.get("thirdpartyvendor").get("name").patchValue(val);
    if (val == "") {
      this.allManufacturerList = [];
    } else {
      this.getAllManufacturerList(val, "Third Paty Vendor");
    }
  }

  onChangeSearchDealer(val) {
    console.log(val);
    this.loadingManufacturerList = true;
    this.isDealerSelected = false;
    this.cutSheetForm.get("dealer").get("name").reset();
    this.cutSheetForm.get("dealer").get("name").patchValue(val);
    console.log(this.cutSheetForm.get("dealer").get("name"));
    console.log(this.cutSheetForm.get("manufacturer"));

    if (val == "") {
      this.allManufacturerList = [];
    } else {
      this.getAllManufacturerList(val, "Dealer");
    }
  }

  onProjectSelected(event, isFromHeader) {
    if (isFromHeader) {
      this.selectedProject = event;
    }
    this.isFromMilStd = false;
    this.isMilStdRecord.emit(this.isFromMilStd);
    this.isCloudLibRecord.emit(this.isFromCloudLib);
    this.cutSheetForm.get("project").reset();
    this.cutSheetForm.get("project").patchValue(event);
    this.cutSheetForm.markAsDirty();
    this.currentProject = this.cutSheetForm.get("project").value || "";
  }

  onProjectInputChange(val) {
    if (val == "") {
      this.projectList = [];
    } else {
      // this.getAllProjects(val);
      this.getUserProjects(val);
    }
  }

  onJSNInputChange(val) {
    if (val == "") {
      this.jsnList = [];
    } else {
      this.getJSNList(val);
    }
  }

  onChangeSearch(val) {
    this.loadingManufacturerList = true;
    this.isManufactureSelected = false;
    this.cutSheetForm.get("manufacturer").get("manufacturer").reset();
    this.cutSheetForm
      .get("manufacturer")
      .get("manufacturer")
      .get("name")
      .patchValue(val);
    if (val == "") {
      this.allManufacturerList = [];
    } else {
      this.getAllManufacturerList(val, "Manufacturer");
    }
  }

  // jsnid from manufacturer list
  getCutsheetDetails(cutsheetId: string): void {
    this.selectedinstalledby = [];
    this.selectedsubtrades = [];
    this.selectedinstallationarea = [];
    this.buildCutsheetForm();
    this._cutSheetService
      .getCutsheetDetailByCutsheetId(cutsheetId)
      .pipe(takeUntil(this.$unsubscribe))
      .subscribe((result) => {
        console.log("cutsheet==>", result);

        if (result && result["id"]) {
          console.log(result);

          this.cutsheetDetails = result;
          this.cutsheetDetails["manufacturer"]?.name
            ? (this.isManufactureSelected = true)
            : false;
          this.cutsheetDetails["dealer"]?.name
            ? (this.isDealerSelected = true)
            : false;
          this.cutsheetDetails["thirdpartyvendor"]?.name
            ? (this.isVendorSelected = true)
            : false;
          this.isFromMilStd = result?.ismillstandard || false;
          this.isMilStdRecord.emit(this.isFromMilStd);
          this.isFromCloudLib = result?.iscloudlibrary || false;
          this.isCloudLibRecord.emit(this.isFromCloudLib);
          // this.images = result.images;
          this.annotationImage = result?.annotationimage;
          // this.galleryImages = this.transformGalleryImages(this.images);

          this.gallery.initializeImages(result)

          this.selectedinstallationarea = this.allInstallationArea.find(
            (item: any) => {
              return +item.id === result?.installationarea;
            }
          );
          this.selectedinstalledby = this.allInstalledBy?.find((item: any) => {
            return +item.id === result?.installedby;
          });
          const selectedsubtradesIds = result?.subtrades
            ?.split(",")
            .map((id) => parseInt(id.trim(), 10));
          this.selectedsubtrades = this.allSubtrades?.filter((option) =>
            selectedsubtradesIds?.includes(+option.id)
          );

          this.cutSheetForm.patchValue(result);

          this.cutSheetForm
            .get("subtrades")
            ?.setValue(this.selectedsubtrades?.map((item) => item?.id));

          this.cutSheetForm
            .get("installationdate")
            .setValue(this.formatDate(result?.installationdate));
          this.cutSheetForm
            .get("thirdpartyinstalldate")
            .setValue(this.formatDate(result?.thirdpartyinstalldate));
          this.cutSheetForm
            .get("thirdpartyinstallcompletedate")
            .setValue(this.formatDate(result?.thirdpartyinstallcompletedate));
          this.cutSheetForm
            .get("shopdrawingsreceiveddt")
            .setValue(this.formatDate(result?.shopdrawingsreceiveddt));
          this.selectedProject = <ProjectModel>(
            this.cutSheetForm.get("project").value
          );
          this.currentJSNOther = result?.jsnother;
          this.JsnName = result?.name;
          this.selectedJSN = result;
          this.loadJsnDepartments(this.selectedJSN.id);
          this.selectedThirdPartVendor = result?.thirdpartyvendor;
          this.selectedDealerInformation = result?.dealer;
          if (this.selectedJSN?.manufacturer) {
            let manufacturer = {
              id: this.selectedJSN?.manufacturer?.id,
              name: this.selectedJSN?.manufacturer?.name,
              manufacturer: {
                id: this.selectedJSN?.manufacturer?.id,
                name: this.selectedJSN?.manufacturer?.name,
                modelname: this.selectedJSN?.modelname,
                modelnumber: this.selectedJSN?.modelnumber,
              },
            };
            this.cutSheetForm.get("manufacturer").patchValue(manufacturer);
            this.manufacturerContactForm.patchValue(
              this.selectedJSN?.manufacturer
            );
            this.selectedManufacturer = result?.manufacturer;

            this.cutSheetForm.get("dealer").patchValue(result?.dealer);
            if (
              !this.selectedJSN?.manufacturer &&
              this.cutSheetForm.get("manufacturer").get("id").value
            ) {
              this.getManufacturerContactByAccountId(
                this.cutSheetForm.get("manufacturer").get("id").value
              );
            }
          }

          this.initialValue = _.cloneDeep(this.cutSheetForm.value);
          this.cutSheetForm.valueChanges
            .pipe
            // debounceTime(100) // Optional: debounce to avoid running on every keystroke
            // takeUntil(this.destroy$)
            ()
            .subscribe((currentFormValues) => {
              this.updatePristineState(
                this.cutSheetForm,
                this.initialValue,
                currentFormValues
              );
            });
        }
        this.getPendingApprovals(cutsheetId);
      });
  }
  updatePristineState(
    control: AbstractControl,
    initialValue: any,
    currentValue: any
  ): void {
    if (control instanceof UntypedFormGroup) {
      // Recurse for each control in the group
      Object.keys(control.controls).forEach((name) => {
        this.updatePristineState(
          control.controls[name],
          initialValue[name],
          currentValue[name]
        );
      });
    } else if (control instanceof UntypedFormArray) {
      // Recurse for each control in the array
      control.controls.forEach((item, index) => {
        this.updatePristineState(
          item,
          initialValue[index],
          currentValue[index]
        );
      });
    } else {
      // console.log(_.isEqual(initialValue, currentValue));

      // This is a FormControl
      // Use lodash's isEqual for a reliable deep comparison
      if (_.isEqual(initialValue, currentValue)) {
        // If values are the same, mark as pristine
        control.markAsPristine();

        // this.markPristineNested();
      } else {
        // If values are different, mark as dirty
        control.markAsDirty();
      }
    }
  }

  markPristineNested() {
    if (!this.cutSheetForm.get("acquisitioncode").dirty) {
      if (this.cutSheetForm.get("acquisitioncode").get('id').value == this.initialValue.acquisitioncode.id) {
        this.cutSheetForm.get("acquisitioncode").markAsPristine();
      }
    }
    //<mildodhide> if (!this.cutSheetForm.get("dodcatcode").dirty) {
    //   if (this.cutSheetForm.get("dodcatcode").get('id').value == this.initialValue.dodcatcode.id) {
    //     this.cutSheetForm.get("dodcatcode").markAsPristine();
    //   }
    // }
  }
  getPendingApprovals(cutsheetId: string) {
    this._cutSheetService
      .getAllExistingApproval(cutsheetId)
      .pipe(takeUntil(this.$unsubscribe))
      .subscribe((result) => {
        console.log(result);
        if (result) {
          this.pendingApprovals = result.pendingFields;
          if (this.pendingApprovals.cost) {
            this.pendingApprovals.unitcost = this.pendingApprovals.cost;
            delete this.pendingApprovals.cost;
          }
          this.pendingApprovalsArray = Object.keys(result.pendingFields);
          this.cutSheetForm.valueChanges.subscribe((res) => {
            console.log(res);
          });
        }
      });
  }

  formatDate(dateString: string): any {
    if (dateString) {
      const date = new Date(dateString);
      return date?.toISOString()?.substring(0, 10);
    }
  }

  getManufacturerContactByAccountId(accountId: string) {
    this._cutSheetService
      .getManufacturerContactByAccountId(accountId)
      .pipe(takeUntil(this.$unsubscribe))
      .subscribe((result) => {
        if (result) {
          this.manufacturerContactForm.patchValue(result);
          this.selectedManufacturer.primarycontact = result;
        }
      });
  }

  getCloudLibraryProjectInfo() {
    this._cutSheetService
      .getCloudLibraryProjectInfo()
      .pipe(takeUntil(this.$unsubscribe))
      .subscribe((res) => {
        if (res && res.status == 200) {
          this.clibProjectId = res?.data?.id;
        }
      });
  }

  onSubmit(clibProjectId?): void {
    if (this.cutSheetForm.valid) {
      let changedValues: any = this.getDirtyValues(this.cutSheetForm);
      console.log("deepclone==>", _.cloneDeep(changedValues));

      const newFiles = this.files.filter((file: any) => {
        return typeof file !== "string";
      });
      if (changedValues?.manufacturer?.name == "") {
        this.cutSheetForm.get("manufacturer")?.get("manufacturer")?.reset();
        this.manufacturerForm
          .get("manufacturer")
          .get("id")
          .setValue(EMPTY_GUID);
      }
      if (
        changedValues?.dealer?.name === "" ||
        changedValues?.dealer?.name === null
      ) {
        this.cutSheetForm.get("dealer")?.reset();
        this.cutSheetForm.get("dealer")?.get("id")?.setValue(EMPTY_GUID);
        this.selectedDealerInformation = [];
      }

      if (
        changedValues?.thirdpartyvendor?.name === "" ||
        changedValues?.thirdpartyvendor?.name === null
      ) {
        this.cutSheetForm.get("thirdpartyvendor")?.reset();
        this.cutSheetForm
          .get("thirdpartyvendor")
          ?.get("id")
          ?.setValue(EMPTY_GUID);
        this.selectedThirdPartVendor = [];
      }

      this.files = newFiles;
      let data = {
        cutsheetData: this.cutSheetForm.value || false,
        filteredValues: changedValues,
        manufacturerData:
          this.manufacturerForm.get("manufacturer").value || false,
        images: this.files,
        clibProjectId: clibProjectId || null,
        imageFormData: this.gallery.save(true)
      };

      console.log(data);

      this.activeModal.close(data);
    } else {
      console.log("invalid");
    }
  }
  @ViewChild('cutsheetGallery') cutsheetGallery: CutsheetGalleryComponent
  refreshImages(showLoader: boolean) {
    this.cutsheetGallery.loadCutSheetDetails(showLoader)
  }
  triggerClick(): void {
    const el: HTMLElement = this.file.nativeElement;
    el.click();
  }

  onSelectFile(event) {
    if (event.target.files.length === 1) {
      if (event.target.files && event.target.files[0]) {
        const reader = new FileReader();
        reader.readAsDataURL(event.target.files[0]); // read file as data url
        const tempArray = this.files.concat(this.images);
        this.files = tempArray;
        this.files.push(event.target.files[0]);
        reader.onload = (event) => {
          // called once readAsDataURL is completed
          this.images.push(event.target["result"]);
          this.galleryImages = this.transformGalleryImages(this.images);
        };
      }
    } else {
      let files = event.target.files;
      const img = [];
      if (files) {
        let count = files.length;
        for (let file of files) {
          const tempArray = this.files.concat(this.images);
          this.files = tempArray;
          this.files.push(file);
          let reader = new FileReader();
          reader.readAsDataURL(file);
          reader.onload = (e: any) => {
            img.push(e.target.result);
            count--;
            this.images.push(e.target.result);
            if (count == 0) {
              this.galleryImages = this.transformGalleryImages(this.images);
            }
          };
        }
      }
    }
    this.imageChanged = true
    // this.isImageUploaded.emit(true);
  }

  deleteImage(index): void {
    this.isImageDelete = true;
    Object.entries(this.annotationImage).forEach(([key, value]) => {
      // Check if the value exists in arrayToMatch
      if (this.images[index] == value) {
        // Push the object (key-value pair) to matchedObjects array
        this.deletedImages[key] = value;
      }
    });
    this.deleletedImageValuesArray = Object.values(this.deletedImages);
    if (
      this.currentJSNOther !== this.cutSheetForm.get("jsnother")?.value ||
      this.currentJSNOther !== undefined ||
      this.JsnName !== this.cutSheetForm.get("name")?.value
    ) {
      const set1 = new Set(this.images);
      const set2 = new Set(this.deleletedImageValuesArray);
      this.finalNotDeletedImages = Array.from(set1).filter(
        (value) => !set2.has(value)
      );
    }
    this.images.splice(index, 1);
    if (this.files.length) {
      this.files.splice(index, 1);
    }
    // this.isImageUploaded.emit(true);
    this.imageChanged = true
    this.galleryImages = this.transformGalleryImages(this.images);
  }

  saveJSN(validate?, isFromCloudLib?): void {

    const modalRef = this._modalService.open(AlertDialogComponent, {
      size: "lg",
      backdrop: "static",
    });
    modalRef.componentInstance.title = `${isFromCloudLib ? "ADD TO CLOUD LIBRARY" : "PROJECT CUTSHEET CHANGES"
      }`;
    modalRef.componentInstance.message1 = isFromCloudLib
      ? "YOU ARE TRYING TO ADD THIS CUTSHEET INTO THE CLOUD LIBRARY."
      : "YOU ARE MAKING CHANGES TO THE PROJECT CUTSHEET FOR JSN " +
      this.selectedJSN.name +
      ". THIS CHANGE WILL ONLY AFFECT THE CUTSHEET FOR THIS PROJECT.";
    modalRef.componentInstance.yes_label = isFromCloudLib
      ? "YES, ADD TO CLOUD LIBRARY"
      : "YES. SAVE CHANGES AND UPDATE PROJECT CUTSHEET";
    modalRef.componentInstance.no_label = isFromCloudLib
      ? "NO, CANCEL THIS OPERATION"
      : "NO, CANCEL CHANGES TO CUTSHEET";
    if ((validate || !this.cutsheetId) && this.cutsheetDetails?.fbximages?.length && this.cutsheetDetails.showglbcopy) {
      modalRef.componentInstance.showMilstdGlbToggle = true;
      modalRef.componentInstance.glbMessage = `Use GLB FROM <span class="dynamics-message p-1">${this.selectedJSN.project.projectname}</span> TO <span class="dynamics-message p-1">${this.selectedProject.projectname}</span> PROJECT?`;
    }

    modalRef.result.then((data) => {
      const isSuccess = data == "success" || data?.action == "success";
      if (isSuccess) {
        if (data?.useMilstdGlb !== undefined) {
          this.cutSheetForm.get('copymilstdglb')?.setValue(data.useMilstdGlb);
          this.cutSheetForm.get('copymilstdglb')?.markAsDirty();
        }
        // if (this.gallery.isValueChanged) {
        //   this.gallery.save()
        //   this.gallery.makeReadOnly$.subscribe((res) => {
        //     if (res) {
        //       this.makeReadOnly$.next(true)
        //     }
        //   })
        // }
        if (JSON.stringify(this.initialValue) ==
          JSON.stringify(this.cutSheetForm.value) && !this.gallery.isValueChanged) {
          return
        }

        // patch for acquisition code
        if (this.pendingApprovalsArray.includes('acquisitioncode')) {
          this.cutSheetForm.get('acquisitioncode').markAsPristine()
        }
        //<mildodhide> if (this.pendingApprovalsArray.includes('dodcatcode')) {
        //   this.cutSheetForm.get('dodcatcode').markAsPristine()
        // }
        let changedValues: any = this.getDirtyValues(this.cutSheetForm);
        console.log("deepclone==>", _.cloneDeep(changedValues));

        // if (changedValues.name != undefined || changedValues.jsnother != undefined) {
        //   const modalRef = this._modalService.open(AlertDialogComponent, {
        //     size: "lg",
        //     backdrop: "static",
        //   });
        //   modalRef.componentInstance.title = `${isFromCloudLib ? "ADD TO CLOUD LIBRARY" : "PROJECT CUTSHEET CHANGES"}`;
        //   modalRef.componentInstance.message1 = 'DO GLOBAL CHANGES FOR JSN ' + this.selectedJSN.name;
        //   modalRef.componentInstance.yes_label = "YES, CHANGE GLOBALLY";
        //   modalRef.componentInstance.no_label = "NO, ONLY FOR THIS PROJECT";

        //   modalRef.result.then((data) => {
        //     if (data == "success") {
        //       this.globalChange = {
        //         isGlobal: true,
        //         old_jsno: this.selectedJSN.name,
        //         old_jsnother: this.selectedJSN.jsnother
        //       };
        //       this.processJSNUpdate(changedValues, true, isFromCloudLib, true);//validate true if change in name

        //     } else {
        //       // this.cutsheetId ? validate = false : validate = true

        //       this.globalChange = {
        //         isGlobal: false,
        //         old_jsno: this.selectedJSN.name,
        //         old_jsnother: this.selectedJSN.jsnother
        //       };
        //       if (this.isFromCloudLib == false &&
        //         this.isFromMainDB == false &&
        //         this.isFromMilStd == false && this.roomByRoomId) {
        //         this.processJSNUpdate(changedValues, false, isFromCloudLib, true);
        //       } else {
        //         const modalRef = this._modalService.open(AlertDialogComponent, {
        //           size: "lg",
        //           backdrop: "static",
        //         });
        //         modalRef.componentInstance.title = 'Alert'
        //         modalRef.componentInstance.message1 = 'Changes made here apply globally. For room-specific updates, make changes from the Room Content List.'
        //         modalRef.result.then((data) => {
        //           if (data == "success") {
        //             this.processJSNUpdate(changedValues, validate, isFromCloudLib, true);
        //           }
        //         })
        //       }
        //     }
        //   });
        // } else {
        // this.cutsheetId ? validate = false : validate = true

        if (changedValues.name != undefined || changedValues.jsnother != undefined) {
          validate = true
        }
        this.processJSNUpdate(changedValues, validate, isFromCloudLib, false);
        // }
      }
    });
  }

  processJSNUpdate(changedValues: any, validate: any, isFromCloudLib: any, useGlobalChange: boolean = false) {

    console.log("changed values==>", changedValues);
    const newFiles = this.files.filter((file: any) => {
      return typeof file !== "string";
    });

    if (
      changedValues?.manufacturer?.name === "" ||
      changedValues?.manufacturer?.name === null
    ) {
      this.cutSheetForm.get("manufacturer")?.get("manufacturer")?.reset();
      this.manufacturerForm
        .get("manufacturer")
        .get("id")
        .setValue(EMPTY_GUID);
    }

    if (
      changedValues?.dealer?.id === "" ||
      changedValues?.dealer?.id === null
    ) {
      console.log("dealer changed");

      this.cutSheetForm.get("dealer")?.reset();
      this.cutSheetForm.get("dealer")?.get("id")?.setValue(EMPTY_GUID);
      try {
        changedValues.dealer.name = "";
        changedValues.dealer.id = EMPTY_GUID;
        console.log(changedValues);
      } catch (e) { }

      this.selectedDealerInformation = [];
    }

    if (
      changedValues?.thirdpartyvendor?.id === "" ||
      changedValues?.thirdpartyvendor?.id === null
    ) {
      this.cutSheetForm.get("thirdpartyvendor")?.reset();
      this.cutSheetForm
        .get("thirdpartyvendor")
        ?.get("id")
        ?.setValue(EMPTY_GUID);

      try {
        changedValues.thirdpartyvendor.name = "";
        changedValues.thirdpartyvendor.id = EMPTY_GUID;
      } catch (e) { }
      this.selectedThirdPartVendor = [];
    }

    this.files = newFiles;
    console.log(this.cutSheetForm.get("dealer"));
    console.log("deepclone2==>", _.cloneDeep(changedValues));

    const filteredValues = useGlobalChange ? { ...this.globalChange, ...changedValues } : changedValues;

    let details = {
      cutsheetData: this.cutSheetForm.value || false,
      manufacturerData:
        this.manufacturerForm.get("manufacturer").value || false,
      images: this.files,
      imageFormData: this.gallery.save(true),
      filteredValues: filteredValues,
      clibProjectId: isFromCloudLib ? this.clibProjectId : null,
    };
    console.log(_.cloneDeep(details));
    //UPDATE JSN DETAILS
    this.AddJSNToProject(details, validate, isFromCloudLib || false);
    // this.addJsnComponent.onSubmit(); call method for update jsn from here
  }

  AddJSNToProject(JSNData, validate?, isFromCloudLib?) {
    if (JSNData.filteredValues.jsnother != undefined && JSNData.filteredValues.jsnother != null && JSNData.filteredValues.jsnother != "") {
      JSNData.filteredValues.jsnotherchange = true
    } else if (JSNData.filteredValues.name != undefined && JSNData.filteredValues.name != null && JSNData.filteredValues.name != "") {
      JSNData.filteredValues.jsnnamechange = true
    }

    return new Promise((resolve, reject) => {
      let images = JSNData.images;
      let obj = JSNData.filteredValues;
      obj.jsn = JSNData.cutsheetData?.id;
      obj.validate = validate;
      obj.project =
        this.currentProject?.id ||
        this.projectId ||
        JSNData.cutsheetData?.project?.id ||
        null;
      if (JSNData?.clibProjectId) {
        obj.project = JSNData?.clibProjectId;
      }
      Object.keys(obj).forEach((k: any, i) => {
        if (k == "manufacturer") {
          obj[k] = JSNData?.manufacturerData?.id;
          obj["manufacturername"] = JSNData?.manufacturerData?.name;
        }
        if (k == "thirdpartyvendor") {
          obj[k] =
            JSNData?.filteredValues?.thirdpartyvendor?.id ||
            this.selectedThirdPartVendor?.id ||
            EMPTY_GUID;
        }
        if (k == "dealer") {
          if (obj[k].name?.email || obj[k].name?.phone) {
            let payload = { email: "", phone: "" };

            if (
              obj[k]?.email ||
              this.cutSheetForm?.get("dealer")?.value?.email
            ) {
              payload.email = obj[k]?.name?.email;
            }

            if (
              obj[k]?.phone ||
              this.cutSheetForm?.get("dealer")?.value?.phone
            ) {
              payload.phone = obj[k]?.name?.phone;
            }

            this.updateDealerInfo(this.selectedDealerInformation?.id, payload);
          }
          //if (!JSNData?.filteredValues?.dealer?.name || JSNData?.filteredValues?.dealer?.name =="") {
          obj[k] =
            JSNData?.filteredValues?.dealer?.id ||
            this.selectedDealerInformation?.id ||
            EMPTY_GUID;

          //obj[k] = EMPTY_GUID;
          // } else if (
          //   JSNData?.filteredValues?.dealer?.name ||
          //   this.selectedDealerInformation
          // ) {
          //   obj[k] =
          //     JSNData?.filteredValues?.dealer?.name?.id ||
          //     this.selectedDealerInformation?.id;
          // }
        }

        /* if (k === "thirdpatyvendor"){
          if(JSNData?.filteredValues?.thirdpartyvendor?.name == "" ||
            JSNData?.filteredValues?.thirdpartyvendor?.name == null ||
            JSNData?.filteredValues?.thirdpartyvendor == undefined) {
          obj[k] = EMPTY_GUID;
        } else if (
          JSNData?.filteredValues?.thirdpartyvendor?.name &&
          k === "thirdpatyvendor"
        ) {
          obj[k] =
            JSNData?.filteredValues?.thirdpartyvendor?.name?.id ||
            this.selectedThirdPartVendor?.id;
        }
      }*/

        if (k == "subtrades") {
          obj[k] = JSNData?.filteredValues.subtrades.join(",");
        }
        if (obj[k] instanceof Object) {
          obj[k] = obj[k].id;
        }
      });
      let formData = this.makeFormData(obj);
      if (this.roomByRoomId) {
        formData.append("forapprovalroom", this.roomByRoomId);
        formData.append("forapprovaldepartment", this.departmentId);
      }

      let titleChanged = false
      let imageChanged = false
      Object.entries(JSNData.imageFormData).forEach(([key, value]: any) => {
        console.log(key, value);
        let i = parseInt(key.replace(/\D/g, ''), 10);
        if (value.url && value.id == EMPTY_GUID && value.blob) {
          formData.append(`img${i}`, value.blob, `upload_${Date.now()}_${i}.png`);
          imageChanged = true
        }
        if (value.title != 'N/A' && value.title != null) {
          if (i == 1) {
            formData.append('mainimagetitle', value.title)
          } else {
            formData.append(`finish${i - 1}imagetitle`, value.title)
          }
          titleChanged = true
        }
      })
      if (titleChanged || Object.keys(JSNData?.filteredValues).length > 3) {
        formData.append('onlyimageupload', 'false')
      } else if (imageChanged && !titleChanged) {
        formData.append('onlyimageupload', 'true')
      }
      // for (let i = 0; i < images.length; i++) {
      //   formData.append("img", images[i]);
      // }
      // for (const [key, value] of (this.gallery.save(true) as any).entries()) {
      //   formData.set(key, value);
      // }
      if (
        (this.currentJSNOther !== this.cutSheetForm.get("jsnother")?.value &&
          this.currentJSNOther !== undefined) ||
        this.JsnName !== this.cutSheetForm.get("name")?.value
      ) {
        if (this.finalNotDeletedImages.length) {
          formData.append(
            "images[]",
            JSON.stringify(this.finalNotDeletedImages)
          );
          formData.append("imagesList", this.finalNotDeletedImages);
        } else {
          formData.append("images[]", JSON.stringify(this.images));
          formData.append("imagesList", this.images);
        }
      }
      if (JSNData?.clibProjectId) {
        this._cutSheetService
          .saveCloudLibJsn(formData)
          .pipe(takeUntil(this.$unsubscribe))
          .subscribe(
            (res) => {
              if (res && res?.id) {
                this._dialogService.showToast(
                  "Cutsheet added to Cloud Library",
                  "success"
                );
              } else if (res == null) {
                //override
                const modalRef = this._modalService.open(AlertDialogComponent, {
                  size: "lg",
                  backdrop: "static",
                });
                modalRef.componentInstance.title = "Override cutsheet item";
                modalRef.componentInstance.message1 =
                  "This cutsheet already exists in the cloud library. Would you like to override it ?";
                modalRef.componentInstance.yes_label = "Yes, Override cutsheet";
                modalRef.componentInstance.no_label = "No, Keep existing";

                modalRef.result.then((data) => {
                  if (data == "success") {
                    formData.append("overrideifexist", "true");
                    this._cutSheetService
                      .saveCloudLibJsn(formData)
                      .pipe(takeUntil(this.$unsubscribe))
                      .subscribe((result) => {
                        if (result) {
                          this._dialogService.showToast(
                            "Cutsheet overridden in Cloud Library",
                            "success"
                          );
                        }
                      });
                  }
                });
              }
              return resolve(res);
            },
            (err) => { }
          );
      } else {
        if (this.isImageDelete) {
          const payload = {
            annotationimage: this.deletedImages,
            jsnother: this.cutSheetForm.get("jsnother")?.value,
            jsn: this.cutSheetForm.get("id")?.value,
            name: this.cutSheetForm.get("name")?.value,
            project: this.cutsheetDetails["project"].id,
          };

          this._cutSheetService
            .deleteImage(payload)
            .pipe(takeUntil(this.$unsubscribe))
            .subscribe(
              (res) => {
                //this.getCutsheetDetails(this.cutsheetId);//REPLACES NEW VALUE WITH OLD
                this.deletedImages = [];
                this.isImageDelete = false;
                return resolve(res);
              },
              (err) => {
                this.getCutsheetDetails(this.cutsheetId);
              }
            );
        }
        this._cutSheetService
          .saveJsn(formData)
          .pipe(takeUntil(this.$unsubscribe))
          .subscribe(
            (res) => {
              if (imageChanged) {
                const autoRefresh = timer(5000, 5000).pipe(take(5))
                autoRefresh.subscribe({
                  next: (res) => {
                    this.refreshImages(false)
                  }
                })
              }
              if (res.message !== "sucess") {
                this._dialogService.showToast(imageChanged ? 'The cutsheet has been saved. It may take 10-15 seconds for the image changes to be visible.' : res.message || 'The cutsheet has been saved.', "success");
              } else {
                if (validate) {
                  //add to project
                  this._dialogService.showToast(
                    "Cutsheet added to project",
                    "success"
                  );
                } else {
                  const isApprovalNeeded = this.checkForApproval();
                  if (isApprovalNeeded) {
                    this._dialogService.showToast(
                      "Updates must be approved before they will appear",
                      "success"
                    );
                  } else {
                    this._dialogService.showToast(
                      "Cutsheet updated",
                      "success"
                    );
                  }
                }
              }
              this.getCutsheetDetails(this.cutsheetId); //REPLACES NEW VALUE WITH OLD
              return resolve(res);
            },
            (err) => {
              if (err?.error?.message == 'This project already contains the specified JSN please try adding Other value' || err?.error?.message == 'This project already contains the specified JSN + Other, please try adding a different Other value') {
                if (this.cutSheetForm.get('name').dirty || this.cutSheetForm.get('jsnother').dirty) {
                  const modalRef = this._modalService.open(InfoDialogComponent, {
                    size: "md",
                    backdrop: "static",
                    centered: true,
                  });
                  modalRef.componentInstance.title = "Same jsn name exists in project";
                  modalRef.componentInstance.message1 =
                    "please try adding a different JSN + Other value";
                  modalRef.componentInstance.no_label = "Close";
                  modalRef.result.then();
                } else {
                  const modalRef = this._modalService.open(AlertDialogComponent, {
                    size: "lg",
                    backdrop: "static",
                  });
                  modalRef.componentInstance.title = "Override cutsheet item";
                  modalRef.componentInstance.message1 =
                    "This cutsheet already exists in the project. Would you like to override it ?";
                  modalRef.componentInstance.yes_label = "Yes, Override cutsheet";
                  modalRef.componentInstance.no_label = "No, Keep existing";

                  modalRef.result.then((data) => {
                    if (data == "success") {
                      formData.append("overrideifexist", "true");
                      this._cutSheetService
                        .overrideJsn(formData)
                        .pipe(takeUntil(this.$unsubscribe))
                        .subscribe((result) => {
                          if (result) {
                            this._dialogService.showToast(
                              "Cutsheet overridden in project",
                              "success"
                            );
                          }
                        });
                    }
                  });
                }
              }
              formData.append("validate", "true");
              // if (validate) {
              //   //add to project
              //   formData.delete("validate");
              //   formData.append("validate", "false");
              //   //this.retryAddJSN(formData);
              // }
              this.getCutsheetDetails(this.cutsheetId);
            }
          );
      }
    });
  }

  checkForApproval() {
    let changedValues = this.getDirtyValues(this.cutSheetForm);
    if (
      changedValues.hasOwnProperty("amps") ||
      changedValues.hasOwnProperty("utility_dedicatedcircuits") ||
      changedValues.hasOwnProperty("acquisitioncode") ||
      //<mildodhide> changedValues.hasOwnProperty("dodcatcode") ||
      changedValues.hasOwnProperty("utility_data") ||
      changedValues.hasOwnProperty("utility_wallblocking") ||
      changedValues.hasOwnProperty("utility_emergencypower") ||
      changedValues.hasOwnProperty("depth") ||
      changedValues.hasOwnProperty("mmdepth") ||
      changedValues.hasOwnProperty("height") ||
      changedValues.hasOwnProperty("mmdepthheight") ||
      changedValues.hasOwnProperty("width") ||
      changedValues.hasOwnProperty("mmdepthwidth") ||
      changedValues.hasOwnProperty("utility_numberofdrops") ||
      changedValues.hasOwnProperty("utility_outlettype") ||
      changedValues.hasOwnProperty("unitcost") ||
      changedValues.hasOwnProperty("totalcost") ||
      changedValues.hasOwnProperty("comment") ||
      changedValues.hasOwnProperty("manufacturer") ||
      changedValues.hasOwnProperty("modelname") ||
      changedValues.hasOwnProperty("modelnumber") ||
      changedValues.hasOwnProperty("mtr") ||
      changedValues.hasOwnProperty("utility_additionaloutlets") ||
      changedValues.hasOwnProperty("utility_1") ||
      changedValues.hasOwnProperty("utility_2") ||
      changedValues.hasOwnProperty("utility_3") ||
      changedValues.hasOwnProperty("utility_4") ||
      changedValues.hasOwnProperty("utility_5") ||
      changedValues.hasOwnProperty("utility_6") ||
      changedValues.hasOwnProperty("worksurfaces") ||
      changedValues.hasOwnProperty("copymilstdglb") ||
      changedValues.hasOwnProperty("showmodel") ||
      changedValues.hasOwnProperty("installationarea") ||
      changedValues.hasOwnProperty("utility_trainingneeded") ||
      changedValues.hasOwnProperty("utility_wallblocking") ||
      changedValues.hasOwnProperty("mountedheight") ||
      changedValues.hasOwnProperty("installedby") ||
      changedValues.hasOwnProperty("installationdate") ||
      changedValues.hasOwnProperty("buildingprotectionreq") ||
      changedValues.hasOwnProperty("verifiedequipfit") ||
      changedValues.hasOwnProperty("weightlbs") ||
      changedValues.hasOwnProperty("subtradereq") ||
      changedValues.hasOwnProperty("subtrades") ||
      changedValues.hasOwnProperty("loadingdockdestination") ||
      changedValues.hasOwnProperty("loadingdockorigin") ||
      changedValues.hasOwnProperty("elevatororigin") ||
      changedValues.hasOwnProperty("destination") ||
      changedValues.hasOwnProperty("installationnote") ||
      changedValues.hasOwnProperty("thirdpartyvendor") ||
      changedValues.hasOwnProperty("thirdpartypocname") ||
      changedValues.hasOwnProperty("thirdpartypocphone") ||
      changedValues.hasOwnProperty("thirdpartypocemail") ||
      changedValues.hasOwnProperty("thirdpartyfieldsurvey") ||
      changedValues.hasOwnProperty("thirdpartyinstallcost") ||
      changedValues.hasOwnProperty("thirdpartyinstalldate") ||
      changedValues.hasOwnProperty("thirdpartyinstallcompletedate") ||
      changedValues.hasOwnProperty("calibrationtesting") ||
      changedValues.hasOwnProperty("shopdrawings") ||
      changedValues.hasOwnProperty("utility_includesinstallations") ||
      changedValues.hasOwnProperty("utility_warrantyterm") ||
      changedValues.hasOwnProperty("shopdrawingsreceiveddt") ||
      changedValues.hasOwnProperty("utility1plumbinglength") ||
      changedValues.hasOwnProperty("utility2electricallength") ||
      changedValues.hasOwnProperty("utility3medicalgaslength") ||
      changedValues.hasOwnProperty("utility4miscgaslength") ||
      changedValues.hasOwnProperty("utility5nonmedgaslength") ||
      changedValues.hasOwnProperty("utility6miscellaneouslength") ||
      changedValues.hasOwnProperty("datautilitylength") ||
      changedValues.hasOwnProperty("dcutilitylength") ||
      changedValues.hasOwnProperty("eputilitylength") ||
      changedValues.hasOwnProperty("requiremodel") ||
      changedValues.hasOwnProperty("manufacturerurl") ||
      changedValues.hasOwnProperty("dealer") ||
      changedValues.hasOwnProperty("drainsize")
    ) {
      return true;
    } else {
      return false;
    }
  }
  retryAddJSN(formData) {
    const modalRef = this._modalService.open(AlertDialogComponent, {
      size: "lg",
      backdrop: "static",
    });
    modalRef.componentInstance.title = "PROJECT CUTSHEET OVERWRITE ";
    modalRef.componentInstance.message1 = `YOU ARE OVERWRITING TO THE PROJECT CUTSHEET FOR JSN ${this.selectedJSN.name}. THIS CHANGE WILL ONLY AFFECT THE CUTSHEET FOR THE SELECTED PROJECT.`;
    modalRef.componentInstance.yes_label = "`YES. OVERWRITE PROJECT CUTSHEET";
    modalRef.componentInstance.no_label =
      "NO, RE-SUBMIT WITH DIFFERENT OTHER VALUE";

    modalRef.result.then((data) => {
      if (data == "success") {
        this._cutSheetService
          .saveJsn(formData)
          .pipe(takeUntil(this.$unsubscribe))
          .subscribe((res) => {
            this._dialogService.showToast("Added JSN to Project", "success");
            this.getCutsheetDetails(this.cutsheetId);
          });
        // this.addJsnComponent.onSubmit(); call method for update jsn from here
      }
    });
  }

  makeFormData(object) {
    const formData = new FormData();
    Object.keys(object).forEach((key) => formData.append(key, object[key]));
    return formData;
  }

  cancelChanges() {
    this.getCutsheetDetails(this.cutsheetId);
  }

  ngAfterViewInit(): void {
    // this.cutSheetForm.statusChanges.subscribe((val)=>{
    //   console.log(val);
    // });
    // this.cutSheetForm.valueChanges.subscribe((res) => {
    //   console.log(res);
    // });
  }

  // getDirtyValues(form: any) {
  //   let dirtyValues: any = {};

  //   Object.keys(form.controls).forEach((key) => {
  //     let currentControl = form.controls[key];
  //     if (currentControl.dirty) {
  //       if (currentControl.controls) {
  //         // Check if the control is a FormGroup or FormArray to recursively call getDirtyValues
  //         dirtyValues[key] = this.getDirtyValues(currentControl);
  //       } else {
  //         dirtyValues[key] = currentControl.value;
  //       }
  //     }
  //   });

  //   return dirtyValues;
  // }
  getDirtyValues(form: UntypedFormGroup | UntypedFormArray): Record<string, any> {
    const dirtyValues: Record<string, any> = {};

    // Iterate over each control in the form group or form array
    Object.keys(form.controls).forEach((key) => {
      const currentControl = form.get(key);

      if (currentControl?.dirty) {
        if (
          currentControl instanceof UntypedFormGroup ||
          currentControl instanceof UntypedFormArray
        ) {
          // If the control is a FormGroup or FormArray, call getDirtyValues recursively
          dirtyValues[key] = this.getDirtyValues(currentControl);

          // Remove empty objects for cleaner output
          if (Object.keys(dirtyValues[key]).length === 0) {
            delete dirtyValues[key];
          }
        } else {
          // If it's a FormControl, add its value directly
          if (!this.pendingApprovals.hasOwnProperty(key)) {
            dirtyValues[key] = currentControl.value;
          }
        }
      }
    });

    return dirtyValues;
  }
  // getDirtyValues(
  //   form: FormGroup | FormArray,
  //   initialValues: Record<string, any>
  // ): Record<string, any> {
  //   const changedValues: Record<string, any> = {};

  //   // Iterate over each control in the form group or form array
  //   Object.keys(form.controls).forEach((key) => {
  //     const currentControl = form.get(key);

  //     // 1. Check if control is dirty and exists.
  //     if (!currentControl || !currentControl.dirty) {
  //       return; // Skip pristine controls
  //     }

  //     // 2. Check for nested FormGroup or FormArray
  //     if (
  //       currentControl instanceof FormGroup ||
  //       currentControl instanceof FormArray
  //     ) {
  //       // Pass the corresponding slice of initialValues to the recursive call
  //       const nestedInitialValues = initialValues[key] || {};
  //       const nestedChangedValues = this.getDirtyValues(
  //         currentControl,
  //         nestedInitialValues
  //       );

  //       // Only add to the result if the nested object has changed values
  //       if (Object.keys(nestedChangedValues).length > 0) {
  //         changedValues[key] = nestedChangedValues;
  //       }
  //     }
  //     // 3. Check for a simple FormControl
  //     else {
  //       // Compare the current value with the initial value for this control
  //       if (currentControl.value !== initialValues[key]) {
  //         changedValues[key] = currentControl.value;
  //       } else {
  //         currentControl.markAsPristine();
  //         currentControl.markAsUntouched();
  //       }
  //     }
  //   });

  //   return changedValues;
  // }

  getOutletMetaData(id, key) {
    if (id && this.outlet_type.length > 0) {
      let outletData = this.outlet_type.find((room) => {
        return room.value == id;
      })[key];
      return outletData;
    }
  }

  getAmpsMetaData(id, key) {
    if (id && this.amps.length > 0) {
      let ampsData = this.amps.find((room) => {
        return room.value == id;
      })[key];
      return ampsData;
    }
  }

  getDrainSizeMetaData(id, key) {
    if (id && this.drain_size?.length > 0) {
      let drainSizeData = this.drain_size?.find((item) => {
        return item.id == id;
      })[key];
      return drainSizeData;
    }
  }


  loadJsnDepartments(jsnId: string): void {
    this._cutSheetService.getJsnDepartments(jsnId).subscribe({
      next: (res) => {
        console.log('jsn departments response:', res);
        const list: any[] = Array.isArray(res)
          ? res
          : (res?.departmentIds || res?.DepartmentIds || res?.departments || []);
        const ids: string[] = list.map((d: any) => d.id);
        this.selectedDepartments = this.availableDepartments.filter((d) =>
          ids.includes(d.id)
        );
      },
      error: () => {
        this.selectedDepartments = [];
      },
    });
  }

  addJsnToDepartment(): void {
    const jsnid = this.selectedJSN?.id || this.cutsheetId;
    if (!jsnid || !this.selectedDepartments?.length) return;
    const payload = {
      jsnid,
      DepartmentIds: this.selectedDepartments.map((d) => ({ id: d.id })),
    };
    this._cutSheetService.addJsnToDepartment(payload).subscribe({
      next: () => {
        this._dialogService.showToast("JSN added to department(s)", "success");
        this.selectedDepartments = [];
      },
      error: (err) => {
        this._dialogService.showToast(
          err?.error?.message || "Failed to add JSN to department",
          "error"
        );
      },
    });
  }

  openAddJsnToRoomDialogue() {
    if (this.selectedProject?.id) {
      const modalRef = this._modalService.open(AddJsnRoomComponent, {
        centered: true,
        size: "lg",
        windowClass: "modal-class",
        backdrop: "static",
      });
      modalRef.componentInstance.projectId = this.selectedProject?.id;
      modalRef.componentInstance.jsnId = this.selectedJSN?.id;
      modalRef.componentInstance.jsnName = this.JsnName;
      modalRef.componentInstance.jsnOther = this.currentJSNOther;
    }
  }

  confirmDelete(content) {
    const modalRef = this._modalService.open(AlertDialogComponent, {
      size: "md",
      backdrop: "static",
    });
    modalRef.componentInstance.title = "Delete JSN";
    modalRef.componentInstance.message1 =
      `ARE YOU SURE YOU WANT TO DELETE THIS JSN FROM ROOM` +
      `${content.roomname}` +
      "?";
    modalRef.componentInstance.yes_label = "Yes, Delete";
    modalRef.componentInstance.no_label = "No, Cancel";
    modalRef.result.then((data) => {
      // on close
      if (data == "success") {
        this.deleteSchedule();
      }
    });
  }
  openAccountDialog(title: string) {
    const modalRef = this._modalService.open(AddAccountDialogComponent, {
      centered: true,
      size: "md",
      windowClass: "modal-class",
      backdrop: "static",
    });
    modalRef.componentInstance.title = title;
    // if (!this.allManufacturerList?.length) {
    if (title === "manufacturer") {
      modalRef.componentInstance.accountName = this.cutSheetForm
        .get("manufacturer")
        .get("manufacturer")
        .get("name").value;
      this.cutSheetForm.get("manufacturer").reset();
    } else if (title === "dealer") {
      modalRef.componentInstance.accountName = this.cutSheetForm
        .get("dealer")
        .get("name").value;
      this.cutSheetForm.get("dealer").reset();
    } else if (title === "3rd party vendor") {
      modalRef.componentInstance.accountName = this.cutSheetForm
        .get("thirdpartyvendor")
        .get("name").value;
      this.cutSheetForm.get("thirdpartyvendor").reset();
    }
    // }
    modalRef.result.then((data) => {
      // on close
      console.log(data);

      if (data == "success") {
        console.log("here");
      }
    });
  }

  deleteSchedule() {
    console.log("JSN Deleted");
  }

  redirectToRooms() {
    localStorage.setItem("isFromCutsheet", "true");
    localStorage.setItem("departmentId", this.projectDetails.departmentId);
    this.activeModal.dismiss("Cross click");
    this.router.navigate(["/projects/" + "room-by-room"], {
      queryParams: {
        projectId: this.projectDetails.projectId,
      },
      state: { projectname: this.projectDetails?.projectname },
    });
    this._cutSheetService.isJsnAddedToRooms.next("");
    this.projectDetails = null;
  }

  showHideContent(value: string) {
    switch (value) {
      case "manufacture-info":
        this.isManufactureInfo = !this.isManufactureInfo;
        break;
      case "utility-requirements":
        this.isUtilityRequirements = !this.isUtilityRequirements;
        break;
      case "information-details":
        this.isInformationDetails = !this.isInformationDetails;
        break;
      case "installation-information":
        this.isInstallationInfo = !this.isInstallationInfo;
        break;

      case "quantity-location":
        this.isQuantityLocation = !this.isQuantityLocation;
        break;
    }
  }

  getAllUtilityLength() {
    this._cutSheetService
      .getAllUtilities()
      .pipe(takeUntil(this.$unsubscribe))
      .subscribe((result) => {
        if (result) {
          this.utilitylengths = result.data;
        }
      });
  }
  //auto calculation from MM to Inch Visa Versa
  autoCalculation(event: any, convertFrom: string) {
    // Return early if the input is empty to avoid setting NaN
    if (!event.target.value) {
      return;
    }

    const inputValue = +event.target.value;
    let calculatedValue: number;
    let targetControlName: string;

    switch (convertFrom) {
      case "depth-inch":
        targetControlName = "mmdepth";
        calculatedValue = inputValue * 25.4;
        break;
      case "depth-MM":
        targetControlName = "depth";
        calculatedValue = inputValue / 25.4;
        break;

      case "width-inch":
        targetControlName = "mmdepthwidth";
        calculatedValue = inputValue * 25.4;
        break;
      case "width-MM":
        targetControlName = "width";
        calculatedValue = inputValue / 25.4;
        break;

      case "height-inch":
        targetControlName = "mmdepthheight";
        calculatedValue = inputValue * 25.4;
        break;
      case "height-MM":
        targetControlName = "height";
        calculatedValue = inputValue / 25.4;
        break;

      // Add a default case to handle unexpected 'convertFrom' values
      default:
        return;
    }

    // Round the number to a maximum of 2 decimal places mathematically
    const finalValue =
      Math.round((calculatedValue + Number.EPSILON) * 100) / 100;

    // Set the value in the form control
    this.cutSheetForm.get(targetControlName).setValue(finalValue);
  }
  // autoCalculation(event: any, convertFrom: string) {
  //   const depthValue = +event.target.value;
  //   switch (convertFrom) {
  //     case "depth-inch":
  //       this.cutSheetForm
  //         .get("mmdepth")
  //         .setValue((depthValue * 25.4).toFixed(2));
  //       break;
  //     case "depth-MM":
  //       this.cutSheetForm.get("depth").setValue((depthValue / 25.4).toFixed(2));
  //       break;

  //     case "width-inch":
  //       this.cutSheetForm
  //         .get("mmdepthwidth")
  //         .setValue((depthValue * 25.4).toFixed(2));
  //       break;
  //     case "width-MM":
  //       this.cutSheetForm.get("width").setValue((depthValue / 25.4).toFixed(2));
  //       break;

  //     case "height-inch":
  //       this.cutSheetForm
  //         .get("mmdepthheight")
  //         .setValue((depthValue * 25.4).toFixed(2));
  //       break;
  //     case "height-MM":
  //       this.cutSheetForm
  //         .get("height")
  //         .setValue((depthValue / 25.4).toFixed(2));
  //       break;
  //   }
  // }

  updateDealerInfo(id: string, payload: any) {
    this._cutSheetService
      .updateDealerInfo(id, payload)
      .pipe(takeUntil(this.$unsubscribe))
      .subscribe(
        (res) => { },
        (err) => {
          console.error(err);
          this.getCutsheetDetails(this.cutsheetId);
        }
      );
  }

  removeSubTrades() {
    if (!this.cutSheetForm.value.subtradereq) {
      this.cutSheetForm.controls["subtrades"].setValue([]);
      this.cutSheetForm.controls["subtrades"].markAsDirty();
    }
  }

  onClearAutoComplete(type: string) {
    switch (type) {
      case "dealer":
        this.selectedDealerInformation = [];
        this.cutSheetForm.get("dealer").reset();

        this.cutSheetForm.get("dealer").markAsDirty();
        this.cutSheetForm.get("dealer").get("id").markAsDirty();
        this.setFormPristine();

        break;

      case "vendor":
        this.selectedThirdPartVendor = [];
        this.cutSheetForm.get("thirdpartyvendor").reset();
        this.cutSheetForm.get("thirdpartypocname").reset();
        this.cutSheetForm.get("thirdpartypocname").setValue("");
        this.cutSheetForm.get("thirdpartypocphone").reset();
        this.cutSheetForm.get("thirdpartypocphone").setValue("");
        this.cutSheetForm.get("thirdpartypocemail").reset();
        this.cutSheetForm.get("thirdpartypocemail").setValue("");

        this.cutSheetForm.get("thirdpartyvendor").markAsDirty();
        this.cutSheetForm.get("thirdpartypocname").markAsDirty();
        this.cutSheetForm.get("thirdpartypocphone").markAsDirty();
        this.cutSheetForm.get("thirdpartypocemail").markAsDirty();
        this.setFormPristine();
        break;
      case "manufacturer":
        this.cutSheetForm.get("manufacturer").reset();
        this.selectedManufacturer = null;
        break;
    }
    this.allManufacturerList = [];
  }

  ngOnDestroy() {
    this.$unsubscribe.next();
    this.$unsubscribe.complete();
    this.createdAccount = null;
    this._cutSheetService.accountDetails.next("");
    this._cutSheetService.isJsnAddedToRooms.next("");
    this.cutSheetForm.reset();
    this.projectDetails = null;
  }
  manageImages() {
    const modalRef = this._modalService.open(CutsheetImagesComponent, {
      centered: true,
      size: "lg",
    });
    modalRef.componentInstance.projectId = this.projectId || null;
    modalRef.componentInstance.jsnId = this.cutsheetId || null;
    modalRef.componentInstance.projectName = this.projectName || null;
    modalRef.result.then((data) => {
      console.log(data);

      if (data) {
        // this.getProjectDetails(this.projectId);
        console.log(data);
        // this.getCutsheetDetails(this.cutsheetId);
      }
    });
  }

  public get isValueChanged(): boolean {
    return (
      JSON.stringify(this.initialValue) !==
      JSON.stringify(this.cutSheetForm.value) || this.imageChanged || this.gallery?.isValueChanged
    );
  }
  public get pendingChanged() {
    function getDirtyControls(form: UntypedFormGroup | UntypedFormArray): string[] {
      let dirtyControls: string[] = [];

      Object.keys(form.controls).forEach((key) => {
        const control = form.controls[key];

        if (control instanceof UntypedFormControl) {
          if (control.dirty) {
            dirtyControls.push(key);
          }
        } else if (
          control instanceof UntypedFormGroup ||
          control instanceof UntypedFormArray
        ) {
          const childDirtyControls = getDirtyControls(control);
          // Prefix keys for nested groups/arrays if you want full paths
          childDirtyControls.forEach((childKey) => {
            dirtyControls.push(`${key}.${childKey}`);
          });
        }
      });

      return dirtyControls;
    }

    // function hasCommonElement(dirtyControls, pendingApprovalsArray) {
    //   return dirtyControls.some((dirty) =>
    //     pendingApprovalsArray.some(
    //       (pending) => dirty === pending || dirty.startsWith(pending + ".")
    //     )
    //   );
    // }

    function hasCommonElement(dirtyControls, pendingApprovalsArray) {
      let hasPending = false;

      for (const dirty of dirtyControls) {
        const isPending = pendingApprovalsArray.some(
          (pending) => dirty === pending || dirty.startsWith(pending + ".")
        );

        if (isPending) {
          hasPending = true;
        } else {
          // found a non-pending field → immediately false
          return false;
        }
      }

      return hasPending;
    }

    return hasCommonElement(
      getDirtyControls(this.cutSheetForm),
      this.pendingApprovalsArray
    );
  }

  toComparableString(value: any): string {
    // For objects (but not null), use JSON.stringify
    if (typeof value === "object" && value !== null) {
      return JSON.stringify(value);
    }
    // For all primitives (string, number, boolean, null, undefined), use String()
    return String(value);
  }
  sameValues(v1, v2) {
    return this.toComparableString(v1) == this.toComparableString(v2);
  }
  openCutsheetGallery() {
    const modalRef = this._modalService.open(CutsheetGalleryComponent, {
      centered: true,
      size: "lg"
    })
    modalRef.componentInstance.isDialog = true
    modalRef.componentInstance.jsnId = this.cutsheetId
    modalRef.componentInstance.projectId = this.projectId
    modalRef.componentInstance.readOnly = this.isReadOnly

  }
}
